export interface LendNavigationSettingItem {
  receiptEnabled: boolean
  isAbbreviationReceiptInfo: boolean
  dueDate: string
  handlingType: string
  shelfType: string
  _deleteHandlingType: boolean
}

export const defaultLendNavigationSettingItem = (): LendNavigationSettingItem => ({
  receiptEnabled: true,
  isAbbreviationReceiptInfo: false,
  dueDate: '',
  handlingType: '',
  shelfType: '',
  _deleteHandlingType: false
})
